export enum ELOQUA {
    URL = "https://s2213.t.eloqua.com/e/f2",
    SITE_ID = "2213",
    MORTGAGE_FORM = "aspnetForm-1c3e3b5b-03fa-4fda-b5cd-94723df3d907",
    AUTO_LOAN_FORM = "auto-loan-results-options"
}

export enum BRANCH_TYPE {
    MACU = 1,
    MACU_ATM = 2,
    PARTNER_ATM = 3,
    // PARTNER_BRANCH = 4, coop/partner branches deprecated
    MACU_SATURDAYS = 5,
    MACU_SPANISH = 6,
}